export async function createConfigurationInstance(rest) {
    const { data: config } = await rest.get("/env.json");
    return {
        original: config,
        rest: {
            baseURL: config.API_SERVER,
        },
        auth: {
            host: config.SSO_HOST,
            realm: config.SSO_REALM,
            resource: config.SSO_RESOURCE,
            clientID: config.SSO_CLIENT_ID,
            scope: ["openid", "email", "profile", "roles"],
        },
    };
}
